module.exports = __webpack_public_path__ + "media/images/og-9530535fe878fd5051631b1969549d72.png";